"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalPunk = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var components_1 = require("../../components");

var ModalPunk = function ModalPunk(_a) {
  var title = _a.title,
      children = _a.children,
      isModalOpen = _a.isModalOpen,
      setModalOpen = _a.setModalOpen,
      theme = _a.theme;
  return react_1["default"].createElement(components_1.ModalContainer, {
    theme: theme,
    isModalOpen: isModalOpen,
    onCloseClicked: setModalOpen
  }, react_1["default"].createElement("section", {
    className: "border-2 rounded-lg border-gray-600 bg-transparent w-full max-h-screen mt-16"
  }, react_1["default"].createElement("div", {
    className: "rounded-t-lg bg-gray-900"
  }, react_1["default"].createElement("div", {
    className: "w-full h-full border-b-4 border-red-700 p-4 md:p-6"
  }, react_1["default"].createElement(basic_frontend_common_1.TitleAbstract, {
    theme: theme
  }, title))), react_1["default"].createElement("div", {
    className: "overflow-y-auto rounded-b-lg bg-gray-200 text-gray-800 p-4 md:p-6"
  }, children)));
};

exports.ModalPunk = ModalPunk;